/** Uno - Planner browser cache async storage prefix */ export const PlannerAsyncStoragePrefix = "Planner";
/** Evo - Planner browser cache async storage prefix */ export const PlannerV2AsyncStoragePrefix = "PlannerV2";
/** Key for storing ViewStore ViewConfig data in localStorage (array order = LRU order, index 0 = most recent) */ export const ViewStoreViewConfigKey = "vstore-vconfig";
/** Key for storing the global task editor render mode preference in localStorage */ export const ViewStoreTaskEditorRenderModeKey = "vstore-task-editor-render-mode";
/**
 * Evo - Planner browser cache async storage schema version
 * upgraded from version 1 to 2 for view config settings
 * upgraded from version 2 to 3 for custom field definitions
 * upgraded from version 3 to 4 for pinned tasks table
 */ export const PlannerV2AsyncStorageSchemaVersionV1 = 4;
/** Uno - Planner browser cache async storage schema version V1
 * This version is used for shipping Mru store persistence - mru items and collection status
 */ export const PlannerAsyncStorageSchemaVersionV1 = 1;
/** Uno - Planner browser cache async storage schema version V2
 * This is the latest supported schema version.
 */ export const PlannerAsyncStorageSchemaVersionV2 = 3;
/** Evo - key paths for the respective object stores defined in the schema */ export var PlannerPersistedObjectStoreKeys = /*#__PURE__*/ function(PlannerPersistedObjectStoreKeys) {
    PlannerPersistedObjectStoreKeys["Mru"] = "server_doc_id";
    PlannerPersistedObjectStoreKeys["Plans"] = "id";
    PlannerPersistedObjectStoreKeys["Buckets"] = "id";
    PlannerPersistedObjectStoreKeys["Tasks"] = "id";
    PlannerPersistedObjectStoreKeys["Status"] = "key";
    PlannerPersistedObjectStoreKeys["Goals"] = "id";
    PlannerPersistedObjectStoreKeys["ViewConfig"] = "viewId";
    PlannerPersistedObjectStoreKeys["Cfd"] = "id";
    PlannerPersistedObjectStoreKeys["PinnedTasks"] = "taskId";
    return PlannerPersistedObjectStoreKeys;
}({});
/** Evo - Index names for the respective object stores defined in the schema */ export var PlannerPersistedObjectStoreIndexNames = /*#__PURE__*/ function(PlannerPersistedObjectStoreIndexNames) {
    PlannerPersistedObjectStoreIndexNames["MruPinnedIndex"] = "isPinnedString";
    PlannerPersistedObjectStoreIndexNames["BucketsPlanIndex"] = "planId";
    PlannerPersistedObjectStoreIndexNames["TasksPlanIndex"] = "planId";
    PlannerPersistedObjectStoreIndexNames["TasksMyDayDateIndex"] = "myDayDate";
    PlannerPersistedObjectStoreIndexNames["TasksAssigneeIdentityIdIndex"] = "assigneeIdentityIds";
    PlannerPersistedObjectStoreIndexNames["GoalsPlanIndex"] = "planId";
    PlannerPersistedObjectStoreIndexNames["CfdPlanIndex"] = "planId";
    return PlannerPersistedObjectStoreIndexNames;
}({});
/** Uno - key paths for the respective object stores defined in the schema */ export var PersistedObjectStoreKeys = /*#__PURE__*/ function(PersistedObjectStoreKeys) {
    PersistedObjectStoreKeys["Mru"] = "server_doc_id";
    PersistedObjectStoreKeys["Plans"] = "id";
    PersistedObjectStoreKeys["Buckets"] = "id";
    PersistedObjectStoreKeys["Tasks"] = "id";
    PersistedObjectStoreKeys["Status"] = "key";
    return PersistedObjectStoreKeys;
}({});
/** Uno - Index names for the respective object stores defined in the schema */ export var PersistedObjectStoreIndexNames = /*#__PURE__*/ function(PersistedObjectStoreIndexNames) {
    PersistedObjectStoreIndexNames["MruPinnedIndex"] = "isPinnedString";
    PersistedObjectStoreIndexNames["BucketsPlanIndex"] = "planId";
    PersistedObjectStoreIndexNames["TasksPlanIndex"] = "planId";
    PersistedObjectStoreIndexNames["TasksMyDayDateIndex"] = "myDayDate";
    PersistedObjectStoreIndexNames["TasksAssignmentsIndex"] = "assigneeIds";
    return PersistedObjectStoreIndexNames;
}({});
/**
 * localStorage key used by the old MyTasks new-experience toggle.
 * Read once during bootstrap to migrate the user's preference into the URL, then removed.
 */ export const NewMyTasksExperienceLocalStorageKey = "planner_useNewMyTasksExperience";
